import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, Signal, viewChild } from '@angular/core';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { ControlCabinetModel } from '@configuration/wizard/models/types/control-cabinet.model';
import { ConfigurationWizardService } from '@configuration/wizard/service/configuration-wizard.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MountingRailComponent } from '@configuration/wizard/layout/mounting-rail/mounting-rail.component';

@Component({
  standalone: false,
  templateUrl: './rail-properties.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-rail-properties',
  providers: [ControlCabinetModel]
})
export class RailPropertiesComponent implements OnInit {
  private mountingRail: Signal<MountingRailComponent | undefined> = viewChild('mountingRail');
  @Output() public finish = new EventEmitter<void>();

  @Input() railArticleUsage?: ArticleUsageVO;
  @Input() openedFromFreeMounting: boolean = false;

  constructor(private wizardService: ConfigurationWizardService, private controlCabinetModel: ControlCabinetModel) {
    this.wizardService.start(this.controlCabinetModel);
    this.wizardService.finishedCreation$.pipe(takeUntilDestroyed()).subscribe(()=> this.finish.emit());

    //skip meta data component
    this.wizardService.nextStep();
  }

  public ngOnInit(): void {
    this.mountingRail()?.setConfiguration(this.controlCabinetModel.currentStep);
  }

  public get submitEnabled(): boolean {
    return this.wizardService.submitEnabled;
  }

  public onFinish(): void {
    this.finish.emit();
  }

  public nextStep(): void {
    this.wizardService.nextStep();
  }
}
